import React from 'react'
import { ButtonProps, Button as ChakraButton } from '@chakra-ui/react'

function Button(props: ButtonProps) {
  return (
    <ChakraButton {...props} />
  )
}

export default Button